import { Component } from 'react';
import classNames from 'classnames';

class PageSidebar extends Component {
    state = {
        isClosed: JSON.parse(window.localStorage.getItem('isSidebarClosed'))
    };

    toggle = () => {
        this.setState(
            prevState => ({
                isClosed: !prevState.isClosed
            }),
            () => window.localStorage.setItem('isSidebarClosed', this.state.isClosed)
        );
    };

    render() {
        return (
            <div className={classNames('page-sidebar', { closed: this.state.isClosed })}>
                <div className="page-sidebar-header" onClick={this.toggle}>
                    <span className="page-sidebar-header-icon">&#8810;</span>
                </div>
                <div className="page-sidebar-body">{this.props.children}</div>
            </div>
        );
    }
}

export default PageSidebar;
